export default __webpack_public_path__ + "static/media/8.d675bc82.png";